// 知识点
import request from '@/router/axios';

let urlPrefix = '/api/exam/ettag';

/**
 * 新增/编辑知识点
 * @param {Object} data 知识点信息
 */
export const editEttag = data => {
    const { tagId } = data;
    let type = tagId ? 'put' : 'post';
    return request(urlPrefix, { data }, type);
};

/**
 * 删除
 * @param {Number} id 知识点id
 */
export const delEttag = id => {
    return request(`${urlPrefix}/${id}`, null, 'delete');
};

/**
 * 获取知识点列表
 */
export const getEttagList = () => {
    return request(`${urlPrefix}/all`);
};